import {
  CHARACTER_ANCHOR_NOTE,
  CHARACTER_CANVAS_HEIGHT,
  CHARACTER_CANVAS_WIDTH,
  CHARACTER_LAYER_RENDER_ORDER,
  type CharacterLayerSlot
} from '../types/character';

/** 기본 베이스 바디(더미). 실제 서비스에서는 characterItems 또는 상점 코스메틱으로 교체 가능 */
export const DEFAULT_CHARACTER_BASE_DATA_URL =
  'data:image/svg+xml,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <rect width="32" height="32" fill="#E8ECF2"/>
  <ellipse cx="16" cy="12" rx="7" ry="8" fill="#D4A574"/>
  <rect x="10" y="18" width="12" height="10" rx="2" fill="#4A6FA5"/>
  <rect x="11" y="26" width="4" height="5" fill="#293044"/>
  <rect x="17" y="26" width="4" height="5" fill="#293044"/>
</svg>`
  );

export function getLayerZIndex(slot: CharacterLayerSlot): number {
  const i = CHARACTER_LAYER_RENDER_ORDER.indexOf(slot);
  return i >= 0 ? i : 0;
}

/** 외부 도구(Aseprite 등) 작업 시 참고용 짧은 가이드 (UI에 표시하지 않고 코드/개발 참고용) */
export const CHARACTER_CREATION_GUIDE = [
  `캔버스: ${CHARACTER_CANVAS_WIDTH}×${CHARACTER_CANVAS_HEIGHT}px, PNG, 투명 배경.`,
  CHARACTER_ANCHOR_NOTE,
  '의상/모자 등 파츠는 베이스와 겹치는 영역만 채우고 나머지는 투명 처리.',
  '학급 상점에서 "캐릭터 코스메틱"으로 등록하면 학생이 포인트로 구매 후 옷장에서 장착합니다.'
].join('\n');
